// Desc: Download component for the homepage
import React from 'react';
const playStoreLogo = require('../../../assets/images/google.webp');

export const AndroidDownload = () => (
  <div>
    <h2 className="text-xl font-bold text-center ">Get it now on</h2>
    <a href="https://play.google.com/store/apps/details?id=com.abluux.woor" target="_blank" rel="noopener noreferrer">
      <img
        src={playStoreLogo}
        alt="Download on Play Store"
        className="w-56 h-auto hover:scale-105 transition-transform duration-300 ease-in-out"
      />
    </a>
  </div>
);

export const IOSDownload = () => (
  <div className="col-sm bg-darkGray flex flex-col items-center justify-center min-h-96 rounded-2xl">
    <a href="https://www.apple.com/app-store/" target="_blank" rel="noopener noreferrer">
      {/* <img src={appStoreLogo} alt="Download on App Store" className="w-36 h-12" /> */}
    </a>
  </div>
);
